/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_CurrentInputs */

const es_user_profile_devices_current = /** @type {(inputs: User_Profile_Devices_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo Actual`)
};

const en_user_profile_devices_current = /** @type {(inputs: User_Profile_Devices_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Device`)
};

/**
* | output |
* | --- |
* | "Current Device" |
*
* @param {User_Profile_Devices_CurrentInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_current = /** @type {((inputs?: User_Profile_Devices_CurrentInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_CurrentInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_current(inputs)
	return en_user_profile_devices_current(inputs)
});
export { user_profile_devices_current as "user.profile.devices.current" }